<div (click)="onAddToCart($event)"
  class="flex flex-col h-full bg-[#dbe9f5] border border-gray-200 rounded-xl shadow-sm hover:border-indigo-500 hover:shadow-md hover:-translate-y-0.5 transition-all group overflow-hidden cursor-pointer">
  <!-- <div class="relative pt-[100%] overflow-hidden">
    <img [ngSrc]="product().imageUrl" [alt]="product().name" class="absolute top-0 left-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" width="200" height="200" priority />
    <div class="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
    <button (click)="onViewDetails()" class="absolute top-2 right-2 w-8 h-8 flex items-center justify-center bg-white/70 backdrop-blur-sm rounded-full text-gray-600 hover:bg-white hover:text-indigo-600 transition-all opacity-0 group-hover:opacity-100 scale-90 group-hover:scale-100">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/><path d="M11 8v6"/><path d="M8 11h6"/></svg>
    </button>
  </div> -->
  <div class="flex flex-col">
    <div class="flex justify-end p-2 bg-white">
      <span class="font-extrabold text-gray-900 text-base">
        {{ product().price | currency:'':'':'1.0-0' }} {{'USERMAG0048' | translate}}
      </span>
    </div>
    <div style="background-color: #dbe9f5;">
      <div class="p-2">
        <div class="fw-500 mb-0.5 tracking-wide text-ellipsis w-full">
          {{ l_ClassName() }}
        </div>
        <div class="fw-500 mb-0.5  tracking-wide text-ellipsis w-full">
          {{ s_ClassName() }}
        </div>
        <div class="fw-500 mb-0.5  tracking-wide text-ellipsis w-full"> {{ product().servicE_NM }}
        </div>
      </div>
    </div>
    <!-- <div class="flex flex-col gap-2 2xl:flex-row 2xl:justify-between 2xl:items-center 2xl:mt-2">
      <span class="font-extrabold text-gray-900 text-base">
        {{ product().price | currency:'':'':'1.0-0' }}
      </span>
      <button (click)="onAddToCart($event)"
        class="px-3 py-1.5 bg-indigo-50 text-indigo-600 text-xs font-bold rounded-md hover:bg-indigo-600 hover:text-white transition-all transform active:scale-95 shadow-sm border border-indigo-100">
        {{ 'product.add' | translate }}
      </button>
    </div> -->
  </div>
</div>